import PendingReviewNonAMHC from "components/pending-review-non-amhc";
import OneOnOneSessionsPageLayout from "./components/layout/OneOnOneSessionsPageLayout";
import OneOnOneSessionsPageContextProvider from "./contexts/OneOnOneSessionsPageContextProvider";
import { useUser } from "contexts/UserContext";

const OneOnOneSessions = () => {
  const { user } = useUser();

  if (!user?.profile_approved_to_use_the_platform) {
    return <PendingReviewNonAMHC />;
  }

  return (
    <OneOnOneSessionsPageContextProvider>
      <OneOnOneSessionsPageLayout />
    </OneOnOneSessionsPageContextProvider>
  );
};

export default OneOnOneSessions;
